import { Card, Badge, Layout, Page, BlockStack, Text, Bleed, Divider, InlineStack, IndexTable, ButtonGroup, Button, TextField, Select, Modal, Link, Icon, Tooltip, Banner, LegacyStack, RadioButton } from '@shopify/polaris';
import React, { useCallback, useEffect, useState } from 'react';
import '../css/styles.css';
import { ShippingIcon } from '../../../../Asests/svgIcon/icon';
import { DI, DIProps } from '../../../../Core';
import { amazon_regions } from '../../Onboarding/components/onboardinghelper';
import { getAmazonLink } from './utils';
import Package_Dimension from './Package_Dimension';
import Ship_From from './Ship_From';
import ShippingServices from './ShippingServices';
import OrderTimeline from './OrderTimeline';
import { InfoMinor } from '@shopify/polaris-icons';
import queryString from 'query-string';
import Skeleton from '../skeleton/skeleton';
import { useTranslation } from 'react-i18next';
import { RenderHeadersAction } from '../../Panel';
import { error } from 'src/Actions';

interface PropsI extends DIProps {
  syncNecessaryInfo: () => void;
  syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
  syncProfileInfo: () => void;
  loginStatus: () => void;
  syncServices: () => void;
}
export interface print_optionsI { label: string, value: string }

const BuyShipping = (props: PropsI) => {
  const { t } = useTranslation();
  const print_options: print_optionsI[] = [
    { label: t('PDF'), value: 'PDF' },
    { label: t('ZPL'), value: 'ZPL' },
    { label: t('PNG'), value: 'PNG' },
  ]

  const queryParams = queryString.parse(props.location.search)

  let currentTime = new Date();
  let year = currentTime.getFullYear();
  let month = (currentTime.getMonth() + 1) < 10 ? '0' + (currentTime.getMonth() + 1) : currentTime.getMonth() + 1;
  let date = currentTime.getDate() < 10 ? '0' + currentTime.getDate() : currentTime.getDate();
  let minDateInString = year + '-' + month + '-' + date;
  let currentTime14 = new Date(currentTime.getTime() + 1209600000)
  year = currentTime14.getFullYear();
  month = (currentTime14.getMonth() + 1) < 10 ? '0' + (currentTime14.getMonth() + 1) : currentTime14.getMonth() + 1;
  date = currentTime14.getDate() < 10 ? '0' + currentTime14.getDate() : currentTime14.getDate();
  let maxDateInString = year + '-' + month + '-' + date;

  const data_from_grid = props.location.state ?? {};

  const [data, setData] = useState<any>(props.location.state ?? {})
  const [data_loading, setDataLoading] = useState(false)
  const [syncLoader, setsyncLoader] = useState(false);

  const [items, setItems] = useState<any[]>(data?.items ?? []);
  const handleItem = useCallback((value: boolean | string, index: number, key: 'value' | 'unit' | 'isHamzat') => {
    setItems((a: any[]) => {
      if (key === 'isHamzat') a[index][key] = value;
      else a[index].weight = { ...a[index].weight, [key]: value, error: false }
      return [...a]
    })
  }, [items])

  const [pckg_dimension, setPckg] = useState({ length: '', width: '', height: '', unit: '', error: false });
  const [pckg_weigth, setPckgWeight] = useState({ value: '1', unit: 'KILOGRAM', error: false });
  const [ship_from, setShipFrom] = useState({
    name: data?.default_ship_from_address?.name ?? '',
    email: data?.default_ship_from_address?.email ?? '',
    phone: data?.default_ship_from_address?.phone ?? '',
    address_line_1: data?.default_ship_from_address?.address_line_1 ?? '',
    address_line_2: data?.default_ship_from_address?.address_line_2 ?? '',
    country: data?.default_ship_from_address?.country ?? '',
    state: data?.default_ship_from_address?.state ?? '',
    city: data?.default_ship_from_address?.city ?? '',
    zip: data?.default_ship_from_address?.zip ?? '',
    tag: data?.default_ship_from_address ? 'Default' : 'Custom',
    error: false, from_warehouse: !!data?.default_ship_from_address
  });

  const [shipDate, setShipDate] = useState({ value: new Date().toISOString().slice(0, 10), error: false });
  const handleShipDateChange = useCallback((newValue: string) => {
    setShipDate({ value: newValue, error: !newValue || new Date(newValue) < new Date(minDateInString) || new Date(newValue) > new Date(maxDateInString) })
  }, []);

  const [service_selected, setServiceSelected] = useState<{ requestToken: string, rateId: string, options: print_optionsI[], row: any, error: boolean, availableValueAddedServiceGroups: any }>({ requestToken: '', rateId: '', options: print_options, row: {}, error: false, availableValueAddedServiceGroups: [] });

  const [selectedPrint, setSelectedPrint] = useState({ value: '', error: false });
  const [selectedPrintOrientation, setSelectedPrintOrientation] = useState({ value: '', error: false });
  const handleSelectChangePrint = useCallback((value: string) => {
    setSelectedPrint((pre: any) => { return { ...pre, value: value, error: false } })
    setSelectedPrintOrientation((pre: any) => { return { ...pre, value: "", error: false } })
  }, [selectedPrint]);
  const handlePrintOrientationChange = useCallback((value: string) => setSelectedPrintOrientation((pre: any) => { return { ...pre, value: value, error: false } }), [selectedPrintOrientation]);

  const [selectedValueAddedServices, setselectedValueAddedServices] = useState<any>([]);

  const [purchaseModal, setPurchaseModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [purchaseResponse, setPurchaseRes] = useState<any>([]);

  const [confirmCancel, setConfirmCancel] = useState(false);

  const getRequestDocumentTypes = (data: any) => {
    let filteredData = data?.supportedDocumentDetails?.filter((document: any) => document?.isMandatory)
    let requestedDocumentTypes = filteredData.map((document: any) => {
      return document.name
    });
    return requestedDocumentTypes ?? []
  }

  const handlePurchase = () => {
    let hasError = false
    if (!pckg_dimension.length || !pckg_dimension.width || !pckg_dimension.height) {
      hasError = true
      setPckg(a => ({ ...a, error: true }))
    }
    if (!pckg_weigth.value || !pckg_weigth.unit) {
      hasError = true
      setPckgWeight(a => ({ ...a, error: true }))
    }
    if (!ship_from.name || !ship_from.address_line_1 || !ship_from.city || !ship_from.country || !ship_from.zip) {
      hasError = true
      setShipFrom(a => ({ ...a, error: true }))
    }
    if (!service_selected.rateId || !service_selected.requestToken) {
      hasError = true;
      setServiceSelected(a => ({ ...a, error: true }))
    }
    if (shipDate.error) {
      hasError = true;
    }
    let error_item = false
    items.map((item: any, index) => {
      if (!item?.weight?.value) {
        setItems((a: any) => {
          a[index].weight = { ...a?.[index]?.weight, error: true }
          return [...a]
        })
        error_item = true
      }
    })
    let tempErr: boolean = false;

    selectedValueAddedServices.forEach((grp: any, index: number) => {
      if (Object?.keys?.(grp?.valueAddedServices)?.length == 0) {
        selectedValueAddedServices[index]['error'] = true;
        if (!hasError) hasError = true
      }
    })

    setselectedValueAddedServices(JSON.parse(JSON.stringify(selectedValueAddedServices)))

    if (selectedPrint.value == "") {
      if (!hasError) hasError = selectedPrint.value == "";
      setSelectedPrint({ ...selectedPrint, error: true })
    }

    if (selectedPrint.value !== "" && selectedPrintOrientation.value == "") {
      if (!hasError) hasError = selectedPrintOrientation.value == "";
      setSelectedPrintOrientation({ ...selectedPrintOrientation, error: true })
    }


    if (hasError || error_item) return;

    setLoader(true);
    setPurchaseModal(false);
    setPurchaseRes([]);
    let shippedDate: any = new Date(shipDate.value);
    shippedDate.setHours(23);
    shippedDate.setMinutes(52);
    shippedDate.setSeconds(30);
    let printOption = service_selected.row?.supportedDocumentSpecifications?.filter((specification: any) => {
      let format = `${specification?.format} (${specification?.size?.length} X ${specification?.size?.width} ${specification?.size?.unit})`
      return format == selectedPrint.value
    })?.[0]?.printOptions?.[0] ?? {};

    let size = service_selected.row?.supportedDocumentSpecifications?.filter((specification: any) => {
      let format = `${specification?.format} (${specification?.size?.length} X ${specification?.size?.width} ${specification?.size?.unit})`
      return format == selectedPrint.value
    })?.[0]?.size ?? {};
    let requestedDocumentTypes = getRequestDocumentTypes(printOption);
    let dpi = printOption?.supportedDPIs?.includes(300) ? 300 : printOption?.supportedDPIs?.[0] ?? null;
    let supportedFileJoiningOptions = printOption?.supportedFileJoiningOptions?.[0] ?? false;
    // let pageLayout = printOption?.supportedPageLayouts?.includes("DEFAULT") ? "DEFAULT" : printOption?.supportedPageLayouts?.[0] ?? "DEFAULT";
    let pageLayout = selectedPrintOrientation.value;
    let body = {
      "request_data": {
        "requestToken": service_selected.requestToken,
        "rateId": service_selected.rateId,
        "documentSpecification": {
          "format": selectedPrint.value.slice(0, selectedPrint.value.indexOf(" (")).trim(), //pdf
          size,
          requestedDocumentTypes,
          dpi,
          pageLayout,
          needFileJoining: supportedFileJoiningOptions
        },
        "valueAddedServices": selectedValueAddedServices ?? []
      },
      "additional_data": {
        "order_data": {
          ...data,
          items: items,
          packages: [{
            dimensions: { ...pckg_dimension },
            weight: { ...pckg_weigth }
          }],
          default_ship_from_address: { ...ship_from, postalCode: ship_from.zip },
          ...(shipDate.value ? { shipDate: shippedDate?.toISOString()?.slice(0, -5) + 'Z' } : {})
        },
        ...(shipDate.value ? { shipDate: shippedDate?.toISOString()?.slice(0, -5) + 'Z' } : {}),
        "selected_rate": service_selected.row
      }
    }

    props.di.POST('amazon/amazon-buy-shipping/purchaseShipment', body).then((response) => {
      if (response.success && response?.data) {
        setPurchaseRes(response.data)
        setPurchaseModal(a => !a);
        getData()
      } else {
        props.error(t(response?.message) ?? t('Failed to purchase'))
      }
      setLoader(false);
    })
  };

  const cancelPurchase = () => {
    setLoader(true)
    props.di.POST('amazon/amazon-buy-shipping/cancelShipment', {
      'shipment_id': data?.shipping_services?.[0]?.shipment_id,
      'tracking_id': data?.shipping_services?.[0]?.tracking_id,
      'shop_id': props.redux?.current?.target?._id,
      'marketplace_reference_id': data?.marketplace_reference_id ?? ''
    }).then((response) => {
      setLoader(false)
      if (response.success) {
        getData();
        props.success(t(response?.message) ?? t('Cancelled successfully'))
      } else {
        props.error(t(response?.message) ?? t('Failed to cancel'))
      }
      setConfirmCancel(false);
    })
  }

  const downloadLabel = () => {
    setLoader(true);
    props.di.POST('amazon/amazon-buy-shipping/getShipmentDocuments', data?.shipping_services ?? {}).then((response) => {
      setLoader(false);
      if (response.success) {

        let packageDocuments = response?.data?.[0]?.packageDocumentDetail?.packageDocuments;

        if (!packageDocuments || !Array.isArray(packageDocuments)) return;

        let errMessage: string[] = [];
        // Iterate over the packageDocuments array
        packageDocuments.forEach((doc: any) => {
          // Check if the document type is 'LABEL' and it has 'contents'
          if (doc.contents) {
            // Construct the download URL
            let fetchDataModified = `data:${doc.format?.toLowerCase() ?? 'pdf'};base64,${doc.contents}`;

            // Create an anchor element for the download
            let a = document.createElement("a");
            a.href = fetchDataModified;
            a.download = `label-${data?.['marketplace_reference_id'] ?? t("N/A")}.${doc.format?.toLowerCase() ?? 'pdf'}`;

            // Trigger the download
            a.click();
          }
          else errMessage.push(doc.type)
        });

        if (errMessage.length > 0) {
          let errStatement: string = getErrorStatement(errMessage);
          props.error(errStatement);
        }
      } else {
        props.error(t(response?.message) ?? t('Failed to download label'))
      }
    })
  }

  const mapWeight = (weight_unit: string) => {
    if (weight_unit === 'OUNCE' || weight_unit === 'OUNCE') return 'OUNCE';
    if (weight_unit === 'POUND' || weight_unit === 'POUNDS') return 'POUND';
    if (weight_unit === 'GRAM' || weight_unit === 'GRAMS') return 'GRAM';
    if (weight_unit === 'KILOGRAM' || weight_unit === 'KILOGRAMS') return 'KILOGRAM'
    return 'KILOGRAM'
  }

  const getData = () => {
    let body = data_from_grid;
    if (queryParams?.id) {
      body = {
        query_type: 'custom',
        source_shop_id: props?.redux?.current?.source?.['_id'],
        target_shop_id: props?.redux?.current?.target?.['_id'],
        filter: {
          user_id: { 1: props.di.user_id },
          object_type: { 1: 'source_order' },
          marketplace: { 1: 'amazon' },
          marketplace_shop_id: { 1: props?.redux?.current?.target?.['_id'] },
          'targets.order_id': { 1: queryParams?.id }
        }
      }
    }
    setDataLoading(true);
    props.di.POST('amazon/amazon-buy-shipping/getAllData', body).then((response) => {
      if (response.success) {
        setData(response.data)

        setItems((response?.data?.items ?? []).map((item: any) => {
          let weight = '';

          if (item?.weight?.unit === 'OUNCE' || item?.weight?.unit === 'OUNCE') weight = `${+weight + +item?.weight?.value * 28.3495}`;
          if (item?.weight?.unit === 'POUND' || item?.weight?.unit === 'POUNDS') weight = `${weight + +item?.weight?.value * 453.592}`;
          if (item?.weight?.unit === 'GRAM' || item?.weight?.unit === 'GRAMS') weight = `${weight + +item?.weight?.value}`;
          if (item?.weight?.unit === 'KILOGRAM' || item?.weight?.unit === 'KILOGRAMS') weight = `${weight + +item?.weight?.value * 1000}`;
          let test = {
            value: weight ? parseFloat(parseFloat(weight).toFixed(3)) : "",
            unit: 'GRAM',
          }



          return { ...item, weight: { ...test, unit: mapWeight(test?.unit ?? '') } }
        }));
        if (response?.data?.shipping_services?.[0]?.label_generated || response?.data?.shipping_services?.[0]?.status?.toLowerCase() === 'cancelled') {
          setPckg({
            length: response?.data.packages?.[0]?.[0]?.dimensions?.length ?? '',
            width: response?.data.packages?.[0]?.[0]?.dimensions?.width ?? '',
            height: response?.data.packages?.[0]?.[0]?.dimensions?.height ?? '',
            unit: response?.data.packages?.[0]?.[0]?.dimensions?.unit ?? '',
            error: false
          });
          setPckgWeight({
            value: response?.data.packages?.[0]?.[0]?.weight?.value ?? '',
            unit: response?.data.packages?.[0]?.[0]?.weight?.unit ?? '',
            error: false
          });
        } else {
          let weight = '';
          response?.data.items?.map((item: any) => {
            if (!item?.weight?.value || !item?.weight?.unit || !item?.qty) return;
            if (item?.weight?.unit === 'OUNCE' || item?.weight?.unit === 'OUNCE') weight = `${+weight + +item?.weight?.value * 28.3495 * +item?.qty}`;
            if (item?.weight?.unit === 'POUND' || item?.weight?.unit === 'POUNDS') weight = `${weight + +item?.weight?.value * 453.592 * +item?.qty}`;
            if (item?.weight?.unit === 'GRAM' || item?.weight?.unit === 'GRAMS') weight = `${weight + +item?.weight?.value * +item?.qty}`;
            if (item?.weight?.unit === 'KILOGRAM' || item?.weight?.unit === 'KILOGRAMS') weight = `${weight + +item?.weight?.value * 1000 * +item?.qty}`;
          })
          setPckgWeight({
            value: weight ? (parseFloat(parseFloat(weight).toFixed(3))).toString() : "",
            unit: 'GRAM',
            error: false
          });
        }
        setShipFrom({
          name: response?.data?.ship_from_address?.[0]?.name ?? response?.data?.default_ship_from_address?.name ?? '',
          email: response?.data?.ship_from_address?.[0]?.email ?? response?.data?.default_ship_from_address?.email ?? '',
          phone: response?.data?.ship_from_address?.[0]?.phone ?? response?.data?.default_ship_from_address?.phone ?? '',
          address_line_1: response?.data?.ship_from_address?.[0]?.address_line_1 ?? response?.data?.default_ship_from_address?.address_line_1 ?? '',
          address_line_2: response?.data?.ship_from_address?.[0]?.address_line_2 ?? response?.data?.default_ship_from_address?.address_line_2 ?? '',
          country: response?.data?.ship_from_address?.[0]?.country ?? response?.data?.default_ship_from_address?.country ?? '',
          state: response?.data.ship_from_address?.[0]?.state ?? response?.data?.default_ship_from_address?.state ?? '',
          city: response?.data.ship_from_address?.[0]?.city ?? response?.data?.default_ship_from_address?.city ?? '',
          zip: response?.data.ship_from_address?.[0]?.zip ?? response?.data?.default_ship_from_address?.zip ?? '',
          tag: response?.data.ship_from_address?.[0]?.tag || response?.data?.default_ship_from_address?.tag || 'Custom',
          error: false, from_warehouse: false
        })
        if (response?.data?.shipping_services?.[0]?.status?.toLowerCase() === 'cancelled')
          setShipDate({
            value: new Date().toISOString().slice(0, 10),
            error: false
          })
        else
          setShipDate({
            value: response?.data?.ship_date?.[0]?.slice(0, -10) ?? new Date().toISOString().slice(0, 10),
            error: false
          })
        if (response?.data?.shipping_services?.[0]?.status?.toLowerCase() === 'cancelled')
          setServiceSelected({
            requestToken: '',
            rateId: '',
            row: {},
            options: print_options,
            error: false,
            availableValueAddedServiceGroups: []
          })
        else
          setServiceSelected({
            requestToken: response?.data?.selected_services?.[0]?.requestId ?? response?.data?.selected_services?.[0]?.requestToken ?? '',
            rateId: response?.data?.selected_services?.[0]?.rateId ?? '',
            row: response?.data?.selected_services?.[0],
            options: print_options,
            error: false,
            availableValueAddedServiceGroups: response?.data?.selected_services?.[0]?.valueAddedServices ?? []
          })
        if (response?.data?.shipping_services?.[0]?.status?.toLowerCase() === 'cancelled') setSelectedPrint({ value: "", error: false })
        else setSelectedPrint({ value: response?.data?.selected_services?.[0]?.label_format ?? "", error: false })

        if (response?.data?.shipping_services?.[0]?.status?.toLowerCase() === 'cancelled') setSelectedPrintOrientation({ value: "", error: false })
        else setSelectedPrintOrientation({ value: response?.data?.selected_services?.[0]?.pageLayout ?? "", error: false })



        setselectedValueAddedServices(response?.data?.selected_services?.[0]?.selectedValueAddedServices ?? [])
      } else props.error(t(response.message) ?? t('Failed to get Order Data'));
      setDataLoading(false)
    })
  }

  const syncStatus = () => {
    setsyncLoader(true);
    props.di.POST('amazon/amazon-buy-shipping/shipOrderOnConnectedMarketplace', {
      order_id: data?.marketplace_reference_id ?? '',
      shop_id: props.redux.current.target._id ?? '',
      tracking_id: data?.shipping_services?.[0]?.tracking_id,
      carrier_name: data?.selected_services?.[0]?.carrierName,
      carrier_id: data?.selected_services?.[0]?.carrierId,
    }).then((res: any) => {
      if (res?.success) props.success(t('Your shipment has been synced successfully on shopify.'));
      else props.error(t(res.message) ?? t("Oops! Something went wrong"));
      setsyncLoader(false);
    });
  }

  useEffect(() => {
    getData()
  }, []);

  useEffect(() => {
    if (service_selected.requestToken === "" || service_selected.rateId === "" || label_generated) return;
    const flushed_service_data = { requestToken: '', rateId: '', options: print_options, row: {}, error: false, availableValueAddedServiceGroups: [] };
    setServiceSelected(flushed_service_data);
    setSelectedPrint({ value: "", error: false });
    setSelectedPrintOrientation({ value: "", error: false })
  }, [items, pckg_dimension, pckg_weigth, ship_from, shipDate])

  const label_generated = !!data?.shipping_services?.[0]?.label_generated

  const rowMarkup = items.map(
    (item: any, index: number) => (
      <IndexTable.Row id={item?.id ?? index} key={item?.id ?? index} position={index}>
        <IndexTable.Cell><div style={{ maxWidth: '356px', whiteSpace: 'normal' }}>{item?.title ?? ''}</div></IndexTable.Cell>
        <IndexTable.Cell>
          <BlockStack gap="100">
            <InlineStack gap="100">
              <Text as="p" fontWeight="regular">
                {t("Price")}:
              </Text>
              <Text as="p" fontWeight="regular">
                {(amazon_regions.find(a => a?.currency === (data?.marketplace_currency ?? ''))?.['currency_symbol'] || '') + item?.marketplace_price}
              </Text>
            </InlineStack>
            <InlineStack gap="100">
              <Text as="p" fontWeight="regular">
                {t("SKU")}:
              </Text>
              <Text as="p" fontWeight="regular">
                {item?.sku ?? ''}
              </Text>
            </InlineStack>
            <InlineStack gap="100" wrap={false} blockAlign='center'>
              {item?.product_identifier && <>

                <Text as="p" fontWeight="regular">
                  {t("ASIN")}:
                </Text>
                <Link target='_blank' onClick={() => window.open(`https://${getAmazonLink(props)}/dp/${item?.product_identifier}`)}>{item?.product_identifier}</Link> </>}
            </InlineStack>
          </BlockStack>
        </IndexTable.Cell>
        <IndexTable.Cell>{item?.qty}</IndexTable.Cell>
        <IndexTable.Cell>
          <div className='Custom__Table--Cell'>
            <InlineStack gap="100" wrap={false}>
              <Select
                value={pckg_weigth.unit || 'KILOGRAM'}
                onChange={(e) => { setPckgWeight(a => ({ ...a, unit: e })) }} label="Weight unit"
                labelHidden
                options={[{ label: t('oz'), value: 'OUNCE' }, { label: t('lb'), value: 'POUND' }, { label: t('gm'), value: 'GRAM' }, { label: t('kg'), value: 'KILOGRAM' }]}
                disabled={label_generated}
              />
              <TextField
                label=""
                value={item?.weight?.value ?? ''}
                onChange={(value) => {
                  value = value.replace(/[a-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,\/]/gi, '');
                  value = value?.[0] === '.' ? '0' + value : value;
                  value = value === '00' ? '0' : value;
                  value = (value.split(".").length - 1 > 1 ? value.slice(0, -1) : value).replace(/^(\d+.?\d{0,2})\d*$/, "$1");
                  handleItem(value, index, 'value')
                }}
                error={item?.weight?.error ?? false}
                autoComplete="off"
                disabled={label_generated}
              />
            </InlineStack>
          </div>
        </IndexTable.Cell>
        <IndexTable.Cell>
          {label_generated ? <Button disabled>{item?.isHamzat ? "Yes" : "No"}</Button> :
            <ButtonGroup variant="segmented">
              <Button pressed={item?.isHamzat} onClick={() => handleItem(true, index, 'isHamzat')}>
                {t("Yes")}
              </Button>
              <Button pressed={!item?.isHamzat} onClick={() => handleItem(false, index, 'isHamzat')}>
                {t("No")}
              </Button>
            </ButtonGroup>
          }
        </IndexTable.Cell>
      </IndexTable.Row>
    ),
  );

  const getErrorStatement = (errData: string[]) => {
    let errStr: string = '';
    if (Array.isArray(errData) && errData.length > 0) {
      errStr = errData.join('');
    }
    return `Error in downloading these documents (${errStr})`;
  }

  const getPrintOptions = () => {
    let options: any = [];

    let singleDoc: any = (service_selected?.row?.supportedDocumentSpecifications ?? [])?.find((doc: any) => {

      let formatted = `${doc?.format} (${doc?.size?.length} X ${doc?.size?.width} ${doc?.size?.unit})`
      return formatted == selectedPrint.value
    })
    let supportedPageLayouts: string[] = singleDoc?.printOptions?.[0]?.supportedPageLayouts ?? [];
    supportedPageLayouts.forEach((singleDoc: any) => options.push({ label: singleDoc, value: singleDoc }))
    return options
  }

  const handleValueAddedServicesChange = (grpIndex: number, valueAddedServiceIndex: number, value: any) => {
    let tempselectedValueAddedServices = JSON.parse(JSON.stringify(selectedValueAddedServices));
    tempselectedValueAddedServices[grpIndex]['valueAddedServices'] = service_selected?.availableValueAddedServiceGroups?.[grpIndex]?.valueAddedServices?.find((doc: any) => doc.id == value);
    tempselectedValueAddedServices[grpIndex]['error'] = false;
    setselectedValueAddedServices(JSON.parse(JSON.stringify(tempselectedValueAddedServices)));
  }

  if (data_loading)
    return <Skeleton />

  return (
    <Page
      fullWidth
      backAction={{ content: t('Products'), onAction: () => { props.history('../allSales') } }}
      title={`${t("Order ID")}: ${data?.marketplace_reference_id ?? ''}`}
      titleMetadata={<InlineStack gap="400">
        {data?.shipping_status?.toLowerCase() === 'shipped' ? <Badge progress="incomplete" tone="success">{t("Shipped")}</Badge> : <Badge progress="incomplete" tone="attention">{t("Unshipped")}</Badge>}
        {data?.shipping_services?.[0]?.status?.toLowerCase() === 'cancelled' && <Badge>{t("Shipment Cancelled")}</Badge>}
      </InlineStack>
      }
      primaryAction={
        <RenderHeadersAction {...props} show_only_lng_switcher />
      }
    >
      <Layout>
        <Layout.Section>
          <BlockStack gap="500">
            <Banner
              title={t("Buy-Shipping feature is in Beta Testing Now!")}
              tone={"warning"}
            >
              <Text as="p"> {t("Buy-Shipping feature is in beta phase. If you face any issue while using it or have any query/feedback kindly Click")} <Link onClick={() => props.history("../support")} >{t("here")}</Link> – {t("we're here to help!")}</Text>
            </Banner>
            <Card>
              <BlockStack gap="500">
                <InlineStack align="space-between" blockAlign='center'>
                  <Text variant="headingMd" as="h6">
                    {t("Order Contents")}
                  </Text>
                  <Text variant="headingMd" as="h6">
                    {t("Total")}: {`${amazon_regions.find(a => a?.currency === (data?.marketplace_currency ?? ''))?.['currency_symbol'] || ''} ${data?.total?.marketplace_price ?? 0}`}
                  </Text>
                </InlineStack>
                <Bleed marginInline="500">
                  <Divider />
                </Bleed>
                <div className='Custom__Table--Shipment'>
                  <IndexTable
                    resourceName={{
                      singular: 'order',
                      plural: 'orders',
                    }}
                    itemCount={items.length ?? 0}
                    headings={[
                      { title: <div>{t("Title")}</div>, id: 'title' },
                      { title: <div>{t("Product Details")}</div>, id: 'product_details' },
                      { title: <div>{t("Inventory")}</div>, id: 'quantity' },
                      { title: <div>{t("Weight")}</div>, id: 'weight' },
                      {
                        title: <InlineStack gap="100" blockAlign='center' wrap={false}>
                          <Text as='p'>{t("Hazardous Material")}:</Text>
                          <Tooltip content={t('Select ‘Yes’ if the item contains hazardous materials.')}>
                            <Icon source={InfoMinor} tone="base" />
                          </Tooltip>
                        </InlineStack>, id: 'hazardous'
                      },
                    ]}
                    selectable={false}
                  >
                    {rowMarkup}
                  </IndexTable>
                </div>
              </BlockStack>
            </Card>
            <Card>
              <BlockStack gap="1000">
                <BlockStack gap="500">
                  <Text variant="headingMd" as="h6">
                    {t("Complete details of the package shipment you want to buy")}
                  </Text>
                  <Bleed marginInline="500">
                    <Divider />
                  </Bleed>
                  <div className='Custom__Layout--Section'>
                    <Layout>
                      <Layout.AnnotatedSection
                        id="package"
                        title={<InlineStack gap="100" blockAlign='center'>
                          <Text as='h2' fontWeight='semibold'>{t("Package Dimension")}<span style={{ color: 'red' }}>*</span>:</Text>
                          <Tooltip content={t('A set of measurements for a three-dimensional object.')}>
                            <Icon source={InfoMinor} tone="base" />
                          </Tooltip>
                        </InlineStack>}
                      >
                        <BlockStack gap="400">
                          <Package_Dimension pckg_dimension={pckg_dimension} setPckg={setPckg} data_loading={data_loading} data={data} />
                        </BlockStack>
                      </Layout.AnnotatedSection>
                    </Layout>
                  </div>
                  <div className='Custom__Layout--Section'>
                    <Layout>
                      <Layout.AnnotatedSection
                        id="weight"
                        title={<InlineStack gap="100" blockAlign='center'>
                          <Text as='h2' fontWeight='semibold'>{t("Package Weight")}<span style={{ color: 'red' }}>*</span>:</Text>
                          <Tooltip content={t('Set your package weight. Note that your package weight should not be greater than items X quantity')}>
                            <Icon source={InfoMinor} tone="base" />
                          </Tooltip>
                        </InlineStack>}
                      >
                        <TextField
                          label=""
                          value={pckg_weigth.value}
                          onChange={(value) => {
                            value = value.replace(/[a-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,\/]/gi, '');
                            value = value?.[0] === '.' ? '0' + value : value;
                            value = (value.split(".").length - 1 > 1 ? value.slice(0, -1) : value).replace(/^(\d+.?\d{0,2})\d*$/, "$1");
                            setPckgWeight(a => ({ ...a, value, error: !value.trim() }))
                          }}
                          error={pckg_weigth.error}
                          disabled={label_generated}
                          autoComplete="off"
                          connectedLeft={
                            <Select
                              value={pckg_weigth.unit}
                              onChange={(e) => { setPckgWeight(a => ({ ...a, unit: e })) }} label={t("Weight unit")}
                              labelHidden
                              options={[{ label: t('oz'), value: 'OUNCE' }, { label: t('lb'), value: 'POUND' }, { label: t('gm'), value: 'GRAM' }, { label: t('kg'), value: 'KILOGRAM' }]}
                              disabled={label_generated}
                            />
                          }
                        />
                      </Layout.AnnotatedSection>
                    </Layout>
                  </div>
                  <div className='Custom__Layout--Section'>
                    <Layout>
                      <Layout.AnnotatedSection
                        id="ship"
                        title={<InlineStack gap="100" blockAlign='center'>
                          <Text as='h2' fontWeight='semibold'>{t("Ship From")}<span style={{ color: 'red' }}>*</span>:</Text>
                          <Tooltip content={t('The address from where you want to ship the order ')}>
                            <Icon source={InfoMinor} tone="base" />
                          </Tooltip>
                        </InlineStack>}
                      >
                        <BlockStack gap="400">
                          <Ship_From ship_from={ship_from} setShipFrom={setShipFrom} data={data} />
                        </BlockStack>
                      </Layout.AnnotatedSection>
                    </Layout>
                  </div>
                  <div className='Custom__Layout--Section'>
                    <Layout>
                      <Layout.AnnotatedSection
                        id="date"
                        title={<InlineStack gap="100" blockAlign='center'>
                          <Text as='h2' fontWeight='semibold'>{t("Ship Date")}:</Text>
                          <Tooltip content={t('Set your date for shipping order')}>
                            <Icon source={InfoMinor} tone="base" />
                          </Tooltip>
                        </InlineStack>}
                      >
                        <TextField
                          label=""
                          type="date"
                          value={shipDate.value}
                          onChange={handleShipDateChange}
                          autoComplete="off"
                          min={minDateInString}
                          max={maxDateInString}
                          error={shipDate.error}
                          disabled={label_generated}
                        />
                      </Layout.AnnotatedSection>
                    </Layout>
                  </div>

                  <div className='Custom__Layout--Section'>
                    <Layout>
                      <Layout.AnnotatedSection
                        id="shipping"
                        title={<InlineStack gap="100" blockAlign='center'>
                          <Text as='h2' fontWeight='semibold'>{t("Shipping Service")}<span style={{ color: 'red' }}>*</span>:</Text>
                          <Tooltip content={t('Select service which suits your order best')}>
                            <Icon source={InfoMinor} tone="base" />
                          </Tooltip>
                        </InlineStack>}
                      >
                        <ShippingServices service_selected={service_selected} setServiceSelected={setServiceSelected} items={items} setItems={setItems} pckg_dimension={pckg_dimension} setPckg={setPckg} pckg_weigth={pckg_weigth} setPckgWeight={setPckgWeight} ship_from={ship_from} setShipFrom={setShipFrom} shipDate={shipDate} setShipDate={setShipDate} data={data} setselectedValueAddedServices={setselectedValueAddedServices} setSelectedPrint={setSelectedPrint} setSelectedPrintOrientation={setSelectedPrintOrientation} />
                      </Layout.AnnotatedSection>
                    </Layout>
                  </div>
                  {service_selected.rateId && <div className='Custom__Layout--Section'>
                    <div className={label_generated ? "card_dull" : undefined}>
                      <Layout>
                        <Layout.AnnotatedSection
                          id="shipping"
                          title={<Text as='h2' fontWeight='semibold'>Value Added Services <span style={{ color: 'red' }}>*</span> :</Text>}
                        >
                          {service_selected.availableValueAddedServiceGroups.filter((serviceGroup: any) => serviceGroup.isRequired).map((serviceGrp: any, serviceGrpIndex: number) => <Card padding={"400"}>
                            <BlockStack gap={"300"}>
                              <Text as='p' variant='bodyLg' fontWeight='bold'>{serviceGrp.groupDescription ?? "N/A"}</Text>
                              <BlockStack gap={"200"}>
                                <div className={selectedValueAddedServices?.[serviceGrpIndex]?.error ? "custom-error-description" : undefined}>
                                  <BlockStack>
                                    {
                                      serviceGrp?.valueAddedServices && serviceGrp?.valueAddedServices?.length > 0 && serviceGrp?.valueAddedServices?.map((valueAddedService: any, valueAddedServiceIndex: number) => {
                                        return <RadioButton
                                          label={
                                            <InlineStack gap={'050'}>
                                              <Text as='p'>{valueAddedService?.name}</Text>
                                              <Text as='p' fontWeight='bold'>(+{valueAddedService?.cost?.value}</Text>
                                              <Text as='p' fontWeight='bold'>{valueAddedService?.cost?.unit})</Text>

                                            </InlineStack>}
                                          id={valueAddedService?.name}
                                          name={"accounts"}
                                          checked={selectedValueAddedServices?.[serviceGrpIndex]?.valueAddedServices?.id == valueAddedService?.id}
                                          onChange={() => handleValueAddedServicesChange(serviceGrpIndex, valueAddedServiceIndex, valueAddedService.id)}
                                        />

                                      }
                                      )
                                    }
                                  </BlockStack>
                                </div>
                                {/* <div className='custom-vas-note'>
                                  <Text as='span' variant='bodyLg' fontWeight='semibold'>Note:</Text>
                                  <Text as='span' variant='bodyMd'>Selecting one option is mandatory to proceed.</Text>
                                </div> */}
                              </BlockStack>
                            </BlockStack>
                          </Card>
                          )}
                        </Layout.AnnotatedSection>
                      </Layout>
                    </div>
                  </div>}
                  {service_selected.rateId && <div className='Custom__Layout--Section'>
                    <Layout>
                      <Layout.AnnotatedSection
                        id="format"
                        title={<InlineStack gap="100" blockAlign='center'>
                          <Text as='h2' fontWeight='semibold'>{t("Label Print Format")}:</Text>
                          <Tooltip content={t('Set Label print format')}>
                            <Icon source={InfoMinor} tone="base" />
                          </Tooltip>
                        </InlineStack>}
                      >
                        <Select
                          label=""
                          options={[{ label: "Please Select", value: "" }, ...service_selected.options]}
                          onChange={handleSelectChangePrint}
                          value={selectedPrint.value}
                          disabled={label_generated}
                          error={selectedPrint.error}
                        />
                      </Layout.AnnotatedSection>
                    </Layout>
                  </div>}
                  {!label_generated && service_selected.rateId && selectedPrint.value != "" && <div className='Custom__Layout--Section'>
                    <Layout>
                      <Layout.AnnotatedSection
                        id="label"
                        title={<InlineStack gap="100" blockAlign='center'>
                          <Text as='h2' fontWeight='semibold'>Label Print Orientation:</Text>
                          <Tooltip content='Set Orientation for your shippling label'>
                            <Icon source={InfoMinor} tone="base" />
                          </Tooltip>
                        </InlineStack>}
                      >
                        <Select
                          label=""
                          value={selectedPrintOrientation.value}
                          // options={[
                          //     { label: 'Default(Portrait)', value: 'DEFAULT' }
                          // ]}
                          options={[{ label: "Please Select", value: "" }, ...getPrintOptions()]}
                          onChange={handlePrintOrientationChange}
                          disabled={label_generated}
                          error={selectedPrintOrientation.error}
                        />
                      </Layout.AnnotatedSection>
                    </Layout>
                  </div>}
                </BlockStack>
                <InlineStack align='end' gap="400">
                  {label_generated && <Button onClick={() => { setConfirmCancel(true) }} disabled={loader} tone="critical">{t("Cancel Buy Shipping")}</Button>}
                  {!label_generated ? <Button onClick={handlePurchase} loading={loader} variant="primary">{t("Purchase Buy Shipping")}</Button> : <Button disabled={loader} onClick={() => { downloadLabel() }} variant="primary">{t("Download Shipping Label")}</Button>}
                  {/* {label_generated && <Button loading={syncLoader} onClick={() => { syncStatus() }} variant="primary">{t("Sync Shipment on Shopify")}</Button>} */}
                </InlineStack>
              </BlockStack>
              <Modal
                open={purchaseModal}
                onClose={() => { setPurchaseModal(false) }}
                title={t("Purchase Complete!")}
                primaryAction={{
                  content: t('Download Shipping Label'),
                  onAction: () => {
                    let packageDocuments = purchaseResponse?.packageDocumentDetails?.[0]?.packageDocuments;

                    if (!packageDocuments || !Array.isArray(packageDocuments)) return;

                    // Iterate over the packageDocuments array
                    let errMessage: string[] = [];
                    packageDocuments.forEach((doc: any) => {
                      // Check if the document type is 'LABEL' and it has 'contents'
                      if (doc.contents) {
                        // Construct the download URL
                        let fetchDataModified = `data:${doc.format?.toLowerCase() ?? 'pdf'};base64,${doc.contents}`;

                        // Create an anchor element for the download
                        let a = document.createElement("a");
                        a.href = fetchDataModified;
                        a.download = `label-${data?.['marketplace_reference_id'] ?? t("N/A")}.${doc.format?.toLowerCase() ?? 'pdf'}`;

                        // Trigger the download
                        a.click();
                      }
                      else errMessage.push(doc.type)
                    });

                    if (errMessage.length > 0) {
                      let errStatement: string = getErrorStatement(errMessage);
                      props.error(errStatement);
                    }

                  },
                }}
              >
                <Modal.Section>
                  <BlockStack gap="500">
                    <BlockStack gap="300" align='center' inlineAlign='center'>
                      <ShippingIcon />
                      <Text as="p" fontWeight="regular">
                        {t("Buy Shipping Successful!")}
                      </Text>
                    </BlockStack>
                    <Divider />
                    <BlockStack gap="200" inlineAlign='center'>
                      <InlineStack gap="500">
                        <Text as="p" fontWeight="regular">
                          {t("Shipping Service")}
                        </Text>
                        <Text as="p" fontWeight="semibold">
                          {service_selected.row?.serviceName ?? ''}
                        </Text>
                      </InlineStack>
                      <InlineStack gap="500">
                        <Text as="p" fontWeight="regular">
                          {t("Ship Date")}
                        </Text>
                        <Text as="p" fontWeight="semibold">
                          {purchaseResponse?.promise?.pickupWindow?.start && new Date(purchaseResponse?.promise?.pickupWindow?.start).toUTCString()}
                          &nbsp;-&nbsp;
                          {purchaseResponse?.promise?.pickupWindow?.end && new Date(purchaseResponse?.promise?.pickupWindow?.end).toUTCString()}
                        </Text>
                      </InlineStack>
                      <InlineStack gap="500">
                        <Text as="p" fontWeight="regular">
                          {t("Tracking ID")}
                        </Text>
                        <Text as="p" fontWeight="semibold">
                          {purchaseResponse?.packageDocumentDetails?.[0]?.trackingId ?? ''}
                        </Text>
                      </InlineStack>
                    </BlockStack>
                    <Divider />
                    <BlockStack inlineAlign='center'>
                      <Text as="p" fontWeight="semibold">
                        Total : {purchaseResponse?.totalCharge?.value ?? ''} {' '} {purchaseResponse?.totalCharge?.unit ?? ''}
                      </Text>
                    </BlockStack>
                  </BlockStack>
                </Modal.Section>
              </Modal>
              <Modal
                open={confirmCancel}
                onClose={() => { setConfirmCancel(false) }}
                title={t("Confirm Cancellation")}
                primaryAction={{
                  content: t('Cancel Buy Shipping'),
                  loading: loader,
                  destructive: true,
                  onAction: cancelPurchase
                }}
              >
                <Modal.Section>
                  <Text as="p" fontWeight="regular">
                    {t("Are you sure you want to cancel your Buy Shipping?")}
                  </Text>
                </Modal.Section>
              </Modal>
            </Card>
          </BlockStack>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <BlockStack gap="500">
            <OrderTimeline data={data} data_loader={data_loading} />
            <Card>
              <BlockStack gap="500">
                <Text variant="headingMd" as="h6">
                  {t("Order Summary")}
                </Text>
                <Bleed marginInline="500">
                  <Divider />
                </Bleed>
                {data?.attributes?.find((a: any) => a.key === 'Amazon LatestShipDate')?.value &&
                  <BlockStack gap="0">
                    <Text variant="headingMd" as="h6">
                      {t("Ship By:")}
                    </Text>
                    <Text variant="headingMd" as="h6" fontWeight='medium' tone="caution">
                      {new Date(data?.attributes?.find((a: any) => a.key === 'Amazon LatestShipDate')?.value)?.toUTCString() ?? t('N/A')}
                    </Text>
                  </BlockStack>}
                {data?.attributes?.find((a: any) => a.key === "Amazon LatestDeliveryDate")?.value &&
                  <BlockStack gap="0">
                    <Text variant="headingMd" as="h6">
                      {t("Deliver By:")}
                    </Text>
                    <Text variant="headingMd" as="h6" fontWeight='medium'>
                      {new Date(data?.attributes?.find((a: any) => a.key === "Amazon LatestDeliveryDate")?.value)?.toUTCString() ?? t('N/A')}
                    </Text>
                  </BlockStack>}
                <BlockStack gap="0">
                  <Text variant="headingMd" as="h6">
                    {t("Shipping Service:")}
                  </Text>
                  <Text variant="headingMd" as="h6" fontWeight='medium'>
                    {data?.shipping_details?.method ?? ''}
                  </Text>
                </BlockStack>
              </BlockStack>
            </Card>
            <Card>
              <BlockStack gap="500">
                <Text variant="headingMd" as="h6">
                  {t("Ship To")}
                </Text>
                <Bleed marginInline="500">
                  <Divider />
                </Bleed>
                <BlockStack gap="0">
                  <Text variant="headingMd" as="h6">
                    {t("Address")}
                  </Text>
                  <Text variant="headingMd" as="h6" fontWeight='medium'>
                    {data?.shipping_address?.[0]?.name ?? t('N/A')}
                  </Text>
                  <Text variant="headingMd" as="h6" fontWeight='medium'>
                    {data?.shipping_address?.[0]?.address_line_1 ?? t('N/A')}
                  </Text>
                  {data?.shipping_address?.[0]?.address_line_2 &&
                    <Text variant="headingMd" as="h6" fontWeight='medium'>
                      {data?.shipping_address?.[0]?.address_line_2 ?? ''}
                    </Text>}
                  {data?.shipping_address?.[0]?.address_line_3 &&
                    <Text variant="headingMd" as="h6" fontWeight='medium'>
                      {data?.shipping_address?.[0]?.address_line_3 ?? ''}
                    </Text>}
                  <Text variant="headingMd" as="h6" fontWeight='medium'>
                    {data?.shipping_address?.[0]?.city ?? ''}
                    {data?.shipping_address?.[0]?.state ? (', ' + (data?.shipping_address?.[0]?.state ?? '')) : ''}
                  </Text>
                  <Text variant="headingMd" as="h6" fontWeight='medium'>
                    {data?.shipping_address?.[0]?.country ?? ''}
                    {data?.shipping_address?.[0]?.zip ? (', ' + (data?.shipping_address?.[0]?.zip ?? '')) : ''}
                  </Text>
                </BlockStack>
                {data?.shipping_address?.[0]?.phone &&
                  <BlockStack gap="0">
                    <Text variant="headingMd" as="h6">
                      {t("Phone Number")}
                    </Text>
                    <Text variant="headingMd" as="h6" fontWeight='medium'>
                      {data?.shipping_address?.[0]?.phone}
                    </Text>
                  </BlockStack>}
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
      </Layout >
    </Page >
  );
}

export default DI(BuyShipping);